import { observable, makeObservable } from 'mobx';

import { NavigationTabs } from '@store/abstract/NavigationTabs';

class TabsNavigationStore {
    @observable
    public navigationTabs: NavigationTabs = new NavigationTabs();

    constructor() {
        makeObservable(this);
    }
}

export const tabsNavigationStore = new TabsNavigationStore();
